import { apiClient } from '@/core/api/client';

/** Feature 095 — care-seeker's own assessments + post-hoc share + account claim. */

export type MyAssessment = {
  id: string;
  status: 'INVITED' | 'IN_PROGRESS' | 'COMPLETED';
  shareStatus: 'SHARED' | 'NONE';
  overallScore?: number | null;
  category?: string | null;
  completedAt?: string | null;
};

export async function getMyAssessments(): Promise<MyAssessment[]> {
  const response = await apiClient.get<MyAssessment[]>('/longevity-assessments/mine');
  return response.data;
}

export async function shareAssessmentResults(id: string): Promise<{ shared: boolean }> {
  const response = await apiClient.post<{ shared: boolean }>(
    `/longevity-assessments/${encodeURIComponent(id)}/share`,
    {},
  );
  return response.data;
}

/** Claim the assessment(s) belonging to the signed-in user (token + email-match). */
export async function claimAssessment(
  linkToken?: string,
): Promise<{ claimed: number; assessmentId: string | null }> {
  const response = await apiClient.post<{ claimed: number; assessmentId: string | null }>(
    '/longevity-assessments/claim',
    linkToken ? { linkToken } : {},
  );
  return response.data;
}
